import transformImage from '../assets/transform_1.jpeg';
import React from 'react';


const About = () => {
  return (
    <div className="font-Poppins py-12 px-1 sm:py-12 lg:py-32 bg-gray-100 text-slate-900 dark:bg-slate-950 dark:text-gray-100">
      <div className="flex flex-col lg:flex-row items-center gap-8 justify-center">
        {/* Image Section */}
        <div className="w-full lg:w-[25%] ">
          <img
            src={transformImage || 'https://d3mbwbgtcl4x70.cloudfront.net/pop_design_for_home_07e28ca41b.webp'}
            alt="About Qoncave"
            className="shadow-lg w-full lg:h-[480px]"
            loading="lazy"
          />
        </div>

        {/* Content Section */}
        <div className="w-full lg:w-1/2 flex flex-col justify-center items-center shadow-2xl bg-white p-4 lg:h-[480px] dark:bg-slate-900">
          {/* Title */}
          <h2 className="text-4xl md:text-4xl font-bold text-slate-950 dark:text-white mb-4">
            About Qoncave
          </h2>
          {/* Blue Line */}
          <div className="h-1.5 w-36 bg-orange-500 mb-6 mt-6 rounded-lg"></div>
          {/* Description */}
          <p className="text-base p-3 leading-relaxed text-gray-700 dark:text-gray-300 h-auto text-center">
            At Qoncave Construction Company, we blend creativity and craftsmanship to transform your house into a beautiful, functional home. Specializing in premium interior and exterior designs, we bring modern aesthetics combined with timeless elegance to life. Our skilled team of artisans and designers is dedicated to delivering exceptional results that reflect your unique style and vision.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
